export const moveDraftUserProject = 'moveDraftUserProject';
